export default __webpack_public_path__ + "static/media/56.5a267c32.png";